import FalconCloseButton from "components/common/FalconCloseButton";
import { useToast } from "context/providers/ToastProvider";
import useToken from "hooks/useToken";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Modal, Row, Spinner, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import Skeleton from 'react-loading-skeleton';

const ModalActualizarDatosFiscalesCliente = ({
    setShowModalActualizarDatos,
    showModalActualizarDatos,
    objDatosFiscales,
    setObjDatosFiscales,
    idSource, //Esta variable indica de donde se abre este Modal : 1 - Desde Nueva Orden, 2 - Desde Detalles de Orden
    GuardarComentario,
    onComentarioAgregado,
}) => {
    const [procesandoModal, setProcesandoModal] = useState(false);
    const { token, setToken, nombreCompleto } = useToken();
    const [tablaRegimenFiscal, settablaRegimenFiscal] = useState([]);
    const [tablaUsoCFDI, settablaUsoCFDI] = useState([]);
    const [paises, setPaises] = useState([]);
    const { register, setValue, reset, handleSubmit, clearErrors, formState: { errors } } = useForm();
    const [cargando, setCargando] = useState(true);
    const { showErrorToast, showSuccessToast } = useToast();
    const [isForeign, setIsForeign] = useState(false);
    const [showGenericos, setShowGenericos] = useState(false);
    /**
     * Actuqalizar datos fiscales
     * @param {any} values
     */

    const onSubmit = (data) => {
        let rfc = (data.vRfc).trim();
        //validaciones sewgun el RFC generico (nacional o extranjero)
        if (rfc === "XEXX010101000" || rfc === "XAXX010101000") {
            if (data.vCp != '61770') {
                showErrorToast("El código postal debe ser 61770 para RFC genéricos.");
                return;
            }
               
            if (data.idCatUsoCFDI != 22) {
                showErrorToast("El uso de CFDI del RFC genérico debe ser: Sin efectos fiscales.");
                return;
            }
                
            if ( data.idCatRegimenFiscal != 12) {
                showErrorToast("El régimen fiscal del RFC genérico debe ser: Sin Obligaciones Fiscales.");
                return;
            }
        }
        
        if (rfc != "XEXX010101000") {
            data.vPaisFacturacion= "";
            data.vNumRegTrib= "";
        }

        if (idSource == 1)
            actualizarDatosFiscalesCliente(data);
        else
            if (idSource == 2)
                actualizarDatosFiscalesOrden(data);
    }

    /**
     * Actuqalizar datos fiscales
     * @param {any} values
     */
    const actualizarDatosFiscalesOrden = async (values) => {
        console.log(values);

        setProcesandoModal(true);

        const response = await fetch("/api/orden/actualizarDatosFiscales/?id=" + objDatosFiscales.idOrden + "&jsonDatosFiscales=" + encodeURIComponent(JSON.stringify(values)), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data.iResponseType == 1) {
                showSuccessToast(data.vMessage);

                var detalles = JSON.parse(data.detalles);
                console.log("detalles Order Update: ", detalles);
                setObjDatosFiscales({
                    ...objDatosFiscales,
                    vRfc: detalles[0].vRfc,
                    vRazonSocial: detalles[0].vRazonSocial,
                    idCatRegimenFiscal: detalles[0].idCatRegimenFiscal,
                    vNumRegTrib: detalles[0].vNumRegTrib,
                    vDireccionFiscal: detalles[0].vDireccionFiscal,
                    vCp: detalles[0].vCp,
                    idCatUsoCFDI: detalles[0].idCatUsoCFDI,
                    vCodigoUso: detalles[0].vCodigoUso,
                    vDescripcionUsoCFDI: detalles[0].vDescripcionUsoCFDI,
                    vCodigoRegimen: detalles[0].vCodigoRegimen,
                    vDescripcionRegimenFiscal: detalles[0].vDescripcionRegimenFiscal,
                    vEmailFacturacion: detalles[0].vEmailFacturacion,
                    vTelefonoFacturacion: detalles[0].vTelefonoFacturacion,
                    vPaisFacturacion: detalles[0].vPaisFacturacion
                })

                GuardarComentario(objDatosFiscales.idOrden, `<b>${nombreCompleto}</b> actualizó los datos fiscales de la orden`, 2, objDatosFiscales, (comentarioBD) => {
                    onComentarioAgregado(comentarioBD);
                }, (error) => {
                    showErrorToast(error);
                });
            }
            else {
                showErrorToast(data.vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalActualizarDatos(false);
        setProcesandoModal(false);
    };

    /**
     * Actualizar datos fiscales
     * @param {any} values
     */
    const actualizarDatosFiscalesCliente = async (values) => {
        console.log(values);

        setProcesandoModal(true);

        const response = await fetch("/api/cliente/actualizarDatosFiscales/?id=" + objDatosFiscales.idClienteAkasia + "&jsonDatosFiscales=" + encodeURIComponent(JSON.stringify(values)), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data.iResponseType == 1) {
                showSuccessToast(data.vMessage);

                var detalles = JSON.parse(data.detalles);
                console.log("detalles Cliente Fiscal Data Update: ", detalles);
                setObjDatosFiscales({
                    ...objDatosFiscales,
                    vRfc: detalles[0].vRfc,
                    vRazonSocial: detalles[0].vRazonSocial,
                    idCatRegimenFiscal: detalles[0].idCatRegimenFiscal,
                    vNumRegTrib: detalles[0].vNumRegTrib,
                    vDireccionFiscal: detalles[0].vDireccionFiscal,
                    vCp: detalles[0].vCp,
                    idCatUsoCFDI: detalles[0].idCatUsoCFDI,
                    vCodigoUso: detalles[0].vCodigoUso,
                    vDescripcionUsoCFDI: detalles[0].vDescripcionUsoCFDI,
                    vCodigoRegimen: detalles[0].vCodigoRegimen,
                    vDescripcionRegimenFiscal: detalles[0].vDescripcionRegimenFiscal,
                    vEmailFacturacion: detalles[0].vEmailFacturacion,
                    vTelefonoFacturacion: detalles[0].vTelefonoFacturacion,
                    vPaisFacturacion: detalles[0].vPaisFacturacion
                })
            }
            else {
                showErrorToast(data.vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalActualizarDatos(false);
        setProcesandoModal(false);
    };

    //OBTENER Lista de Modulos No vinculados
    const ObtenerListaRegimenesFiscales = async () => {
        setCargando(true);
        const response = await fetch("/api/orden/ObtenerListaCatalogosFiscales", {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
            setCargando(false);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            settablaRegimenFiscal(data['table1']);
            settablaUsoCFDI(data['table2']);
            setValue("vPaisFacturacion", objDatosFiscales.vPaisFacturacion);
            setCargando(false);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            setCargando(false);
        }
    };

    /**
     * Obtiene los paises del Cat Sat
     */
    const ObtenerCatPaises = async () => {
        const response = await fetch("/api/contabilidad/CatalogoSAT/ObtenerCatPaises",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();
            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);
                setPaises(ObjDetalles.table2);
            } else {
                showErrorToast(data.vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    useEffect(() => {
        if (objDatosFiscales.vRfc === "XEXX010101000") {
            setIsForeign(true);
        } else {
            setIsForeign(false);
        }
    }, [objDatosFiscales.vRfc]);


    return (
        <Modal
            show={showModalActualizarDatos}
            onHide={() => reset()}
            onShow={() => { ObtenerListaRegimenesFiscales(); ObtenerCatPaises(); }}
            size="lg"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className="bg-light">
                <Modal.Title className="text-primary fs-2">
                    <FontAwesomeIcon icon="file-invoice" className="me-2" /> Editar Datos Fiscales
                </Modal.Title>
                <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalActualizarDatos(false); }} />
            </Modal.Header>

            <Form noValidate onSubmit={handleSubmit(onSubmit)}>
                <Modal.Body className="bg-white">
                    {cargando ? (
                        <>
                            <Card className="mb-3 border border-200 shadow-none">
                                <Card.Header className="bg-light py-2 d-flex justify-content-between align-items-center">
                                    <Skeleton width={180} />
                                    <Skeleton width={80} height={20} />
                                </Card.Header>
                                <Card.Body>
                                    <Row className="g-3">
                                        <Col md={6}><Skeleton width={80} className="mb-1" /><Skeleton height={30} /></Col>
                                        <Col md={6}><Skeleton width={120} className="mb-1" /><Skeleton height={30} /></Col>
                                        <Col md={6}><Skeleton width={100} className="mb-1" /><Skeleton height={30} /></Col>
                                        <Col md={6}><Skeleton width={90} className="mb-1" /><Skeleton height={30} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card className="border border-200 shadow-none">
                                <Card.Header className="bg-light py-2">
                                    <Skeleton width={200} />
                                </Card.Header>
                                <Card.Body>
                                    <Row className="g-3">
                                        <Col md={12}><Skeleton width={130} className="mb-1" /><Skeleton height={50} /></Col>
                                        <Col md={4}><Skeleton width={100} className="mb-1" /><Skeleton height={30} /></Col>
                                        <Col md={4}><Skeleton width={120} className="mb-1" /><Skeleton height={30} /></Col>
                                        <Col md={4}><Skeleton width={120} className="mb-1" /><Skeleton height={30} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </>
                    ) : (
                        <>
                            {/* SECCIÓN 1: Identificación Fiscal */}
                    <Card className="mb-3 border border-200 shadow-none">
                        <Card.Header className="bg-light py-2 d-flex justify-content-between align-items-center">
                            <h6 className="mb-0 text-700">
                                <FontAwesomeIcon icon="id-card" className="me-2 text-primary" /> Identificación Fiscal
                            </h6>
                            {isForeign ? (
                                <Badge bg="warning" text="dark">EXTRANJERO</Badge>
                            ) : (
                                <Badge bg="success">MEXICANO</Badge>
                            )}
                        </Card.Header>
                        <Card.Body>
                            <Row className="g-3">
                                {/* RFC */}
                                <Col md={6}>
                                    <Form.Group>
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <Form.Label className="fs--1 fw-semi-bold mb-0">RFC</Form.Label>
                                            <a 
                                                href="#!" 
                                                className="text-decoration-none small" 
                                                onClick={(e) => { 
                                                    e.preventDefault(); 
                                                    setShowGenericos(!showGenericos); 
                                                }}
                                            >
                                                {showGenericos ? 'Ocultar RFC Genéricos' : 'RFC Genéricos'}
                                            </a>
                                        </div>
                                        {showGenericos && (
                                            <div className="d-flex gap-3 mb-2 flex-wrap bg-light p-2 rounded border">
                                                <Form.Check 
                                                    type="radio"
                                                    name="rfc-generico"
                                                    id="rfc-nacional"
                                                    label={<span style={{fontSize: '0.8rem'}}>XAXX010101000 (Nacional)</span>}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setValue('vRfc', 'XAXX010101000');
                                                            setValue('vCp', '61770');
                                                            setValue('idCatUsoCFDI', 22);
                                                            setValue('idCatRegimenFiscal', 12);
                                                            setIsForeign(false);
                                                            clearErrors('vRfc');
                                                            setShowGenericos(false);
                                                        }
                                                    }}
                                                />
                                                <Form.Check 
                                                    type="radio"
                                                    name="rfc-generico"
                                                    id="rfc-extranjero"
                                                    label={<span style={{fontSize: '0.8rem'}}>XEXX010101000 (Extranjero)</span>}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setValue('vRfc', 'XEXX010101000');
                                                            setValue('vCp', '61770');
                                                            setValue('idCatUsoCFDI', 22);
                                                            setValue('idCatRegimenFiscal', 12);
                                                            setIsForeign(true);
                                                            clearErrors('vRfc');
                                                            setShowGenericos(false);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        )}
                                        <Form.Control
                                            size="sm"
                                            autoComplete="off"
                                            type="text"
                                            className="shadow-none border-300"
                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                            defaultValue={objDatosFiscales.vRfc}
                                            isInvalid={!!errors.vRfc}
                                            {...register('vRfc', {
                                                required: 'El RFC es obligatorio',
                                                maxLength: 13,
                                                minLength: 12,
                                                pattern: /^[A-ZÑ&]{3,4}\d{6}(?:[A-Z\d]{3})?$/
                                            })}
                                            onChange={(event) => {
                                                let rfc = (event.target.value).trim().toUpperCase();
                                                if (rfc === "XEXX010101000" || rfc === "XAXX010101000") {
                                                    setValue('vCp', '61770');
                                                    setValue("idCatUsoCFDI", 22);
                                                    setValue("idCatRegimenFiscal", 12);
                                                }
                                                setIsForeign(rfc === "XEXX010101000");
                                            }}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.vRfc && errors.vRfc.message}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                                {/* Razón Social */}
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 fw-semi-bold">Razón Social</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            autoComplete="off"
                                            type="text"
                                            className="shadow-none border-300"
                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                            defaultValue={objDatosFiscales.vRazonSocial}
                                            isInvalid={!!errors.vRazonSocial}
                                            {...register('vRazonSocial', {
                                                required: 'La Razón Social es obligatoria',
                                                maxLength: 300,
                                                minLength: 1,
                                                pattern: /[^|]{1,300}/
                                            })}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.vRazonSocial && errors.vRazonSocial.message}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                                {/* Num Reg Trib (Solo extranjero) */}
                                {isForeign && (
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="fs--1 fw-semi-bold">Num. Reg. Tributario</Form.Label>
                                            <Form.Control
                                                size="sm"
                                                autoComplete="off"
                                                type="text"
                                                className="shadow-none border-300"
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                defaultValue={objDatosFiscales.vNumRegTrib}
                                                isInvalid={!!errors.vNumRegTrib}
                                                {...register('vNumRegTrib', { maxLength: 40, minLength: 1 })}
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.vNumRegTrib && errors.vNumRegTrib.message}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                )}

                                {/* Régimen Fiscal */}
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 fw-semi-bold">Régimen Fiscal</Form.Label>
                                            <Form.Select
                                                size="sm"
                                                className="shadow-none border-300"
                                                defaultValue={objDatosFiscales.idCatRegimenFiscal}
                                                isInvalid={!!errors.idCatRegimenFiscal}
                                                {...register("idCatRegimenFiscal", { required: true })}
                                            >
                                                <option value="">Selecciona un régimen</option>
                                                {tablaRegimenFiscal.map((regimen, index) => (
                                                    <option key={index} value={regimen.idCatRegimenFiscal}>
                                                        {regimen.vCodigoRegimen} - {regimen.vDescripcionRegimenFiscal}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                    </Form.Group>
                                </Col>

                                {/* Uso CFDI */}
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 fw-semi-bold">Uso de CFDI</Form.Label>
                                            <Form.Select
                                                size="sm"
                                                className="shadow-none border-300"
                                                defaultValue={objDatosFiscales.idCatUsoCFDI}
                                                isInvalid={!!errors.idCatUsoCFDI}
                                                {...register("idCatUsoCFDI", { required: true })}
                                            >
                                                <option value="">Selecciona un uso de CFDI</option>
                                                {tablaUsoCFDI.map((uso, index) => (
                                                    <option key={index} value={uso.idCatUsoCFDI}>
                                                        {uso.vCodigoUso} - {uso.vDescripcionUsoCFDI}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    {/* SECCIÓN 2: Contacto y Ubicación */}
                    <Card className="border border-200 shadow-none">
                        <Card.Header className="bg-light py-2">
                            <h6 className="mb-0 text-700">
                                <FontAwesomeIcon icon="map-marker-alt" className="me-2 text-primary" /> Contacto y Ubicación
                            </h6>
                        </Card.Header>
                        <Card.Body>
                            <Row className="g-3">
                                {/* País (Solo extranjero) */}
                                {isForeign && (
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="fs--1 fw-semi-bold">País</Form.Label>
                                            <Form.Select
                                                size="sm"
                                                className="shadow-none border-300"
                                                defaultValue={objDatosFiscales.vPaisFacturacion}
                                                isInvalid={!!errors.vPaisFacturacion}
                                                {...register("vPaisFacturacion", { required: 'El país es obligatorio para facturar al extranjero.' })}
                                            >
                                                <option value="">Seleccione un País</option>
                                                {paises.map((pais, index) => (
                                                    <option key={index} value={pais.cShortName}>
                                                        {pais.cShortName} - {pais.vName}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">{errors.vPaisFacturacion && errors.vPaisFacturacion.message}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                )}

                                {/* Código Postal */}
                                <Col md={isForeign ? 6 : 12}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 fw-semi-bold">Código Postal</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="number"
                                            className="shadow-none border-300"
                                            autoComplete="off"
                                            defaultValue={objDatosFiscales.vCp}
                                            isInvalid={!!errors.vCp}
                                            {...register('vCp', { required: 'El CP es obligatorio', maxLength: 6, minLength: 4 })}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.vCp && errors.vCp.message}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                                {/* Dirección Fiscal */}
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 fw-semi-bold">Dirección Fiscal</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            size="sm"
                                            className="shadow-none border-300"
                                            autoComplete="off"
                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                            defaultValue={objDatosFiscales.vDireccionFiscal}
                                            isInvalid={!!errors.vDireccionFiscal}
                                            {...register('vDireccionFiscal', { required: 'La direccion fiscal es obligatoria', maxLength: 300, minLength: 10 })}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.vDireccionFiscal && errors.vDireccionFiscal.message}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                                {/* Correo */}
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 fw-semi-bold">Correo Facturación</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="text"
                                            className="shadow-none border-300"
                                            autoComplete="off"
                                            defaultValue={objDatosFiscales.vEmailFacturacion}
                                            isInvalid={!!errors.vEmailFacturacion}
                                            {...register("vEmailFacturacion", { maxLength: 120, minLength: 5, pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: "Email incorrecto." } })}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.vEmailFacturacion && errors.vEmailFacturacion.message}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                                {/* Teléfono */}
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 fw-semi-bold">Teléfono Facturación</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="text"
                                            className="shadow-none border-300"
                                            autoComplete="off"
                                            defaultValue={objDatosFiscales.vTelefonoFacturacion}
                                            isInvalid={!!errors.vTelefonoFacturacion}
                                            {...register("vTelefonoFacturacion", { required: false, maxLength: 20, minLength: 5, pattern: { value: /^[+][0-9]+$/, message: "Debe iniciar con el prefijo: +" } })}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.vTelefonoFacturacion && errors.vTelefonoFacturacion.message}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    </>
                    )}

                </Modal.Body>
                
                <Modal.Footer className="bg-light border-top-0">
                    <Button onClick={() => setShowModalActualizarDatos(false)} variant="light" className="rounded-pill px-4">
                        Cancelar
                    </Button>
                    {procesandoModal ? (
                        <Button variant="primary" disabled className="rounded-pill px-4">
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                            Procesando...
                        </Button>
                    ) : (
                        <Button type="submit" variant="primary" className="rounded-pill px-4">
                            Guardar Cambios
                        </Button>
                    )}
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

ModalActualizarDatosFiscalesCliente.propTypes = {
    setShowModalActualizarDatos: PropTypes.func,
    showModalActualizarDatos: PropTypes.bool,
    objDatosFiscales: PropTypes.object,
    setObjDatosFiscales: PropTypes.func,
    idSource: PropTypes.number,
    GuardarComentario: PropTypes.func,
    onComentarioAgregado: PropTypes.func
};


export default ModalActualizarDatosFiscalesCliente;
